import React, { useState } from 'react';
import { Form, Input } from 'antd';
import SearchIcon from 'assets/Icons/search';
import styled from 'styled-components';
import LeftTimeTrackerStaffList from './LeftTimeTrackerStaffList';

const LeftTimeTracker = () => {
  const [text, setText] = useState('');

  return (
    <LeftBox>
      <WrapperInputSearch>
        <Input
          value={text}
          onChange={(e) => {
            setText(e.target.value);
          }}
          suffix={<SearchIcon fill={'#fff'} />}
          placeholder='Search by Staff’s Name'
          className='search-input'
        />
      </WrapperInputSearch>
      <Form.Item name='staffId' noStyle>
        <LeftTimeTrackerStaffList textSearch={text} />
      </Form.Item>
    </LeftBox>
  );
};

export default LeftTimeTracker;

const LeftBox = styled.div`
  padding: 1rem;
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  background: #fff;
  box-shadow: 8px 8px 16px 0 rgba(0, 0, 0, 0.15);
`;

const WrapperInputSearch = styled.div`
  width: 100%;
  .search-input.ant-input-affix-wrapper {
    border-radius: 100px;
    padding: 0px;
    .ant-input-suffix {
      display: flex;
      width: 56px;
      height: 56px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 100px 100px 0px;
      background: #2d6772;
    }
    input {
      border-radius: 100px;
      padding: 24px;
      height: 56px;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px; /* 166.667% */
      text-transform: capitalize;
      align-self: center;
    }
    border: 3px solid #2d6772;
    background: #fff;
  }
`;
